import { DEFAULT_LOCALE } from './constants';
import { SUPPORT_LOCALES, type LocaleCode } from './locales';

export function getLocaleFromPath(path: string, useDefault = true) {
    const pathStrings = path.split('/');

    if (SUPPORT_LOCALES.includes(pathStrings[1])) {
        return pathStrings[1] as LocaleCode;
    }

    return useDefault ? DEFAULT_LOCALE : null;
}

function parseQuery(search: string) {
    return search.split(/[?&]/).reduce(
        (result, item) => {
            if (!item) return result;

            const kv = item.split('=');

            result[kv[0]] = kv[1];

            return result;
        },
        {} as Record<string, string>,
    );
}

export function getLocaleFromQuery(search: string, useDefault = true) {
    const query: Record<string, string> = parseQuery(search);

    if (SUPPORT_LOCALES.includes(query.locale)) {
        return query.locale as LocaleCode;
    }

    return useDefault ? DEFAULT_LOCALE : null;
}

export function getLocaleFromURL(url: string): LocaleCode {
    try {
        const urlObj = new URL(url);

        const pathLocale = getLocaleFromPath(urlObj.pathname, false);

        if (pathLocale) return pathLocale;

        const queryLocale = getLocaleFromQuery(urlObj.search, false);

        if (queryLocale) return queryLocale;

        return DEFAULT_LOCALE;
    } catch (e) {
        console.error(e);
        return DEFAULT_LOCALE;
    }
}
